import React from 'react';
import ReactDOM from 'react-dom/client';

import reportWebVitals from './reportWebVitals';

import { AuthProvider } from './providers/auth'
import { MainCheckinProvider } from './providers/mainCheckin'
import { ThemesProvider } from './providers/theme'

import App from './App'
import initSentry from './config/sentry';

// Inicializar Sentry de forma assíncrona para não bloquear a renderização
// Isso garante que a aplicação carregue primeiro, independente do Sentry
setTimeout(() => {
  try {
    initSentry();
  } catch (error) {
    console.warn('Falha crítica na inicialização do Sentry:', error);
  }
}, 0);

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <AuthProvider>
    <MainCheckinProvider>
      <ThemesProvider>
        <App />
      </ThemesProvider>
    </MainCheckinProvider>
  </AuthProvider>
);

reportWebVitals();
